import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { ExportAccountsOptions } from "../../../types/enums";
import { useMemo } from "react";

type Props = {
  option: string;
  isSelectedAll: boolean;
  selectedItemList: string[];
  setOption: (el: ExportAccountsOptions) => void;
  hideDataSource?: boolean;
};

export const SelectedExportOptions = ({
  option,
  selectedItemList,
  isSelectedAll,
  setOption,
  hideDataSource,
}: Props) => {
  const optionList = useMemo(
    () => [
      {
        label: ExportAccountsOptions.all,
        disabled: false,
        value: ExportAccountsOptions.all,
        isHide: false,
      },

      {
        label: `${ExportAccountsOptions.selected}${
          option === ExportAccountsOptions.selected
            ? `: ${isSelectedAll ? "All" : selectedItemList.length}`
            : ""
        }`,
        disabled: false,
        value: ExportAccountsOptions.selected,
        isHide: false,
      },

      {
        label: ExportAccountsOptions.source,
        disabled: false,
        value: ExportAccountsOptions.source,
        isHide: hideDataSource,
      },
    ],
    [isSelectedAll, option, selectedItemList],
  );

  return (
    <FormControl sx={{ padding: 0, alignItems: "flex-start" }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={option}
        value={option}
        name="radio-buttons-group"
        onChange={(e, el) => setOption(el as ExportAccountsOptions)}
      >
        {optionList.map(({ label, value, isHide }) => {
          if (isHide) return null;
          return (
            <FormControlLabel
              key={label}
              value={value}
              control={<Radio />}
              label={label}
              style={{ margin: 0 }}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};
